export default __webpack_public_path__ + "static/media/spot-icon-products.bfed64f8.svg";